import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionOverlay',
  props: {
    isOverlayVisible: { type: Boolean },
    learnMoreUrl: null
  },
  setup(__props: any) {

const props = __props as {
  isOverlayVisible: boolean
  learnMoreUrl: string
}



const slotContainer = ref<HTMLElement | null>(null)

const styleObject = computed(() => ({
  opacity: props.isOverlayVisible ? 0.25 : 1,
  pointerEvents: props.isOverlayVisible ? 'none' : 'auto',
}))

const onClick = () => {
  window.open(props.learnMoreUrl)
}

return { __sfc: true,props, slotContainer, styleObject, onClick, VsText, VsButton }
}

})